var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 36C71.25 55.468 55.468 71.25 36 71.25C16.532 71.25 0.75 55.468 0.75 36C0.75 16.532 16.532 0.75 36 0.75C55.468 0.75 71.25 16.532 71.25 36Z",
    stroke: "#E8E9E9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 51C18 49.8954 18.8954 49 20 49H52C53.1046 49 54 49.8954 54 51V53H18V51Z",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 49V34",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49V34",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42L27 41",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5795 37.3823C37.8726 37.0897 37.873 36.6148 37.5803 36.3217C37.2877 36.0285 36.8128 36.0281 36.5197 36.3208L33.3131 39.522C33.02 39.8147 33.0196 40.2895 33.3122 40.5827C33.6049 40.8758 34.0798 40.8762 34.3729 40.5836L37.5795 37.3823ZM41.1868 37.7824C41.4799 37.4897 41.4803 37.0149 41.1877 36.7217C40.895 36.4286 40.4201 36.4282 40.127 36.7209L33.7139 43.1233C33.4207 43.416 33.4204 43.8908 33.713 44.184C34.0057 44.4771 34.4805 44.4775 34.7737 44.1849L41.1868 37.7824Z",
    fill: "#FFA89E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 49V34",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2699 16.8282C20.3496 16.4894 20.6519 16.25 20.9999 16.25H26.9999H32.9999H38.9999H44.9999H50.9999C51.348 16.25 51.6503 16.4894 51.73 16.8282L54.7668 29.7345C55.3695 32.2961 53.4259 34.75 50.7944 34.75C49.3152 34.75 47.9955 33.9567 47.2789 32.7425C46.4796 33.9424 45.1149 34.75 43.5334 34.75C41.9671 34.75 40.5793 33.9469 39.7731 32.7208C38.9661 33.9399 37.5823 34.75 35.9999 34.75C34.4176 34.75 33.0338 33.9399 32.2268 32.7208C31.4205 33.9469 30.0328 34.75 28.4665 34.75C26.885 34.75 25.5203 33.9424 24.7209 32.7425C24.0044 33.9567 22.6847 34.75 21.2054 34.75C18.5739 34.75 16.6304 32.2961 17.2331 29.7345L20.2699 16.8282ZM32.9835 30.0509C32.8814 31.7865 34.2614 33.25 35.9999 33.25C37.7385 33.25 39.1184 31.7865 39.0163 30.0509L38.2928 17.75H33.7071L32.9835 30.0509ZM40.514 29.9665L40.5412 30.4286C40.6344 32.0129 41.9463 33.25 43.5334 33.25C45.3963 33.25 46.8077 31.5687 46.4856 29.7342L46.4851 29.7317L44.3707 17.75H39.7954L40.5138 29.9629C40.5138 29.9641 40.5139 29.9653 40.514 29.9665ZM32.2045 17.75H27.6292L25.5148 29.7317L25.5146 29.7328C25.1914 31.5678 26.6031 33.25 28.4665 33.25C30.0536 33.25 31.3655 32.0129 31.4587 30.4286L31.4861 29.9629L32.2045 17.75ZM26.106 17.75H21.594L18.6932 30.0781C18.3121 31.6981 19.5412 33.25 21.2054 33.25C22.4578 33.25 23.5294 32.351 23.747 31.1177L24.0376 29.471L26.106 17.75ZM47.9623 29.471L45.8939 17.75H50.4059L53.3066 30.0781C53.6878 31.6981 52.4587 33.25 50.7944 33.25C49.5421 33.25 48.4705 32.351 48.2529 31.1177L47.9632 29.4764L47.9623 29.471Z",
    fill: "#EC5341"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.3b083f310d22e8b6678a102617a18091.svg";
export { ForwardRef as ReactComponent };